module.exports = __webpack_public_path__ + "static/media/43_B.ce7fc766.png";